import { ElementType } from "@easy-email-pro-core/constants";
import { ElementChildren, ForEachElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";

export type ForEachElementProps = ForEachElement["data"] & {
  idx?: string | null;
  children?: ElementChildren | ForEachElement["children"];
};

export function ForEach(props: ForEachElementProps) {
  const { idx, children: propsChildren, ...rest } = props;

  const node: ForEachElement = {
    type: ElementType.FOR_EACH,
    data: { ...rest },
    attributes: {},
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
